import {createContext, useContext, useEffect, useState} from 'react';
import {useAuth} from '@/context/AuthContext';
import {api} from '@/lib/api';

const empty = {items: [], loading: true, error: false};
const Context = createContext(empty);
export const useProfessionalBookings = () => useContext(Context);

// One refresh for the workspace and the service navigation, scoped to the signed-in
// professional. The server resolves assignments, including historical artist aliases.
export function ProfessionalBookingsProvider({children}) {
  const {workspace, user, studio} = useAuth();
  const scope = workspace?.role === 'artist' ? `${studio?.id}:${user?.id}:${workspace.artist_profile_id}` : null;
  const [state, setState] = useState({...empty, scope: null});
  useEffect(() => {
    if (!scope) return undefined;
    let active = true, generation = 0;
    const refresh = async () => {
      if (document.visibilityState === 'hidden') return;
      const current = ++generation;
      try {
        const items = await api.get('/team/booking-requests', {params: {status: 'pending'}});
        if (!Array.isArray(items)) throw new Error('Invalid booking response');
        if (active && current === generation) setState({scope, items, loading: false, error: false});
      } catch {
        if (active && current === generation) setState(old => ({...(old.scope === scope ? old : empty), scope, loading: false, error: true}));
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('tps:data-changed', refresh);
    document.addEventListener('visibilitychange', refresh);
    const timer = window.setInterval(refresh, 30000);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      window.removeEventListener('tps:data-changed', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [scope]);
  return <Context.Provider value={scope && state.scope === scope ? state : empty}>{children}</Context.Provider>;
}
